var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:['sidebar-toggle-button', _vm.icon],attrs:{"circle":"","type":"text"},on:{"click":_vm.toggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }